import React from 'react';
import { CircularProgress, Box } from '@mui/material';

export interface AppSectionLoaderProps {
    status: boolean;
}

const AppSectionLoader: React.FC<AppSectionLoaderProps> = ({ status }) => {
    if (!status) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.25)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
            }}
        >
            <CircularProgress size={32} />
        </Box>
    );
};

export default AppSectionLoader;
